<template>
  <div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <h4 class="d-flex align-items-center">
        <font-awesome-icon icon="fas fa-laptop-house" />
        <span class="ml-1"
          >{{
            $router.currentRoute.name == "invoice-copy" ? "複製" : ""
          }}發票資料</span
        >
      </h4>

      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-3" @submit.prevent="handleSubmit(onSubmit)">
          <div class="mt-2 mt-sm-3 position-relative">
            <b-row>
              <!-- Invoice number -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="發票編號"
                  rules="required"
                  vid="v_invoice_number"
                >
                  <b-form-group
                    label="發票編號："
                    label-for="invoice_number"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-input-group>
                      <b-form-input
                        id="invoice_number"
                        v-model="newInvoiceData.invoice_number"
                        placeholder="輸入發票編號"
                        :state="getValidationState(validationContext)"
                        @blur="validateInvoiceNumber"
                        @input="onInvoiceNumberInput"
                        :disabled="loadingInvoiceNumber || !ability.can('edit_number', 'invoice_form')"
                        :readonly="!ability.can('edit_number', 'invoice_form')"
                      />
                      <b-input-group-append>
                        <b-button
                          variant="outline-secondary"
                          @click="getNextInvoiceNumber"
                          :disabled="loadingInvoiceNumber || !ability.can('edit_number', 'invoice_form')"
                          size="sm"
                        >
                          <b-spinner small v-if="loadingInvoiceNumber" />
                          <span v-else>自動</span>
                        </b-button>
                      </b-input-group-append>
                       <b-form-input
                        id="invoice_number_remark"
                        class="ml-1"
                        v-model="newInvoiceData.invoice_number_remark"
                        placeholder="輸入發票編號備註"
                        :state="getValidationState(validationContext)"
                      />
                    </b-input-group>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                    <small
                      v-if="invoiceNumberValidation.message"
                      :class="
                        invoiceNumberValidation.isValid
                          ? 'text-success'
                          : 'text-danger'
                      "
                    >
                      {{ invoiceNumberValidation.message }}
                    </small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- customer_id -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_customer_id"
                >
                  <b-form-group
                    label="客戶："
                    label-for="customer_id"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="customer_id"
                      v-model="newInvoiceData.customer_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="customerOptions"
                      :clearable="false"
                      label="name_cn"
                      :reduce="(option) => option.id"
                      placeholder="選擇客戶"
                      :filter="customerSearch"
                    >
                      <template #option="{ name_cn, user_number }">
                        [{{ user_number }}] {{ name_cn }}
                      </template>
                      <template #selected-option="{ name_cn, user_number }">
                        [{{ user_number }}] {{ name_cn }}
                      </template>
                    </v-select>

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- quotation -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="報價單："
                  label-for="quotation_id"
                  label-cols-md="3"
                >
                  <v-select
                    id="quotation_id"
                    v-model="newInvoiceData.quotation_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="
                      (newInvoiceData.customer_id &&
                        quotationOptions.filter(
                          (item) =>
                            item.customer_id == newInvoiceData.customer_id
                        )) ||
                      []
                    "
                    :clearable="true"
                    label="id"
                    :reduce="(option) => option.id"
                    :placeholder="
                      newInvoiceData.customer_id ? '選擇報價單' : '請先選擇客戶'
                    "
                    :disabled="!newInvoiceData.customer_id"
                    :filter="quotationSearch"
                  >
                    <template #option="{ quotation_number, name_cn }">
                      {{ quotation_number }} {{ name_cn }}
                    </template>
                    <template #selected-option="{ quotation_number, name_cn }">
                      {{ quotation_number }} {{ name_cn }}
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>

              <!-- invoice_date -->
              <b-col cols="12" md="6">
                <!-- <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_invoice_date"
                > -->
                <b-form-group
                  label="發單日期："
                  label-for="invoice_date"
                  label-cols-md="3"
                >
                  <flat-pickr
                    v-model="newInvoiceData.invoice_date"
                    class="form-control"
                    :config="{
                      allowInput: true,
                      altInput: true,
                      altFormat: 'Y-m-d',
                      dateFormat: 'Y-m-d',
                    }"
                    placeholder="輸入YYYY-MM-DD"
                  />
                  <!-- <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback> -->
                </b-form-group>
                <!-- </validation-provider> -->
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- invoice_type -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_invoice_type_id"
                >
                  <b-form-group
                    label="類別："
                    label-for="invoice_type"
                    label-cols-md="3"
                  >
                    <v-select
                      id="invoice_type"
                      v-model="newInvoiceData.invoice_type_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="invoiceTypeOptions"
                      :clearable="false"
                      label="name"
                      :reduce="(option) => option.id"
                      placeholder="選擇類別"
                    >
                    </v-select>
                    <!-- @change="handleInvoiceTypeChange" -->

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- project_id -->
              <!-- <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_project_id"
                >
                  <b-form-group
                    label="項目："
                    label-for="id"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="project_id"
                      v-model="newInvoiceData.project_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="
                        (newInvoiceData.customer_id &&
                          projectOptions.filter(
                            (item) =>
                              item.customer_id == newInvoiceData.customer_id
                          )) ||
                        []
                      "
                      :clearable="false"
                      label="project_name"
                      :reduce="(option) => option.id"
                      :placeholder="
                        newInvoiceData.customer_id ? '選擇項目' : '請先選擇客戶'
                      "
                      :disabled="!newInvoiceData.customer_id"
                      :filter="projectSearch"
                    >
                      <template #option="{ project_name, project_number }">
                        [{{ project_number }}] {{ project_name }}
                      </template>
                      <template
                        #selected-option="{ project_name, project_number }"
                      >
                        [{{ project_number }}] {{ project_name }}
                      </template>
                    </v-select>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col> -->

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- project_name -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_project_name"
                >
                  <b-form-group
                    label="項目名稱："
                    label-for="id"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="project_name"
                      v-model="newInvoiceData.project_name"
                      placeholder="輸入項目名稱"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- address -->
              <b-col cols="12" md="6">
                <!-- <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_address"
                > -->
                <b-form-group
                  label="施工地址："
                  label-for="address"
                  label-cols-md="3"
                >
                  <b-form-input
                    id="address"
                    v-model="newInvoiceData.address"
                    placeholder="輸入施工地址"
                  />
                  <!-- :state="getValidationState(validationContext)"
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback> -->
                </b-form-group>
                <!-- </validation-provider> -->
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- customer name_cn-->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_name_cn"
                >
                  <b-form-group
                    label="單據抬頭："
                    label-for="c_name_cn"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="c_name_cn"
                      v-model="newInvoiceData.name_cn"
                      placeholder="輸入單據抬頭"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- customer name_en-->
              <b-col cols="12" md="6">
                <!-- <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_name_en"
                > -->
                <b-form-group
                  label="系統帳號名稱："
                  label-for="c_name_en"
                  label-cols-md="3"
                >
                  <b-form-input
                    id="c_name_en"
                    v-model="newInvoiceData.name_en"
                    placeholder="輸入系統帳號名稱"
                  />
                  <!-- :state="getValidationState(validationContext)"
                    class="required"
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback> -->
                </b-form-group>
                <!-- </validation-provider> -->
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- customer mobile-->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_mobile"
                >
                  <b-form-group
                    label="聯絡電話："
                    label-for="customer_mobile"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="customer_mobile"
                      v-model="newInvoiceData.mobile"
                      placeholder="輸入聯絡電話"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- customer email-->
              <b-col cols="12" md="6">
                <!-- <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required|email"
                  vid="v_email"
                > -->
                <b-form-group
                  label="電郵地址："
                  label-for="email"
                  label-cols-md="3"
                >
                  <!-- class="required" -->
                  <b-form-input
                    id="customer_email"
                    v-model="newInvoiceData.email"
                    placeholder="輸入電郵地址"
                  />
                  <!-- :state="getValidationState(validationContext)"
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback> -->
                </b-form-group>
                <!-- </validation-provider> -->
              </b-col>
            </b-row>
            <!-- 工資 -->
            <h5 class="my-2 mb-1">項目摘要</h5>
            <hr />
            <div>
              <b-row
                v-for="(cost, index) in newInvoiceData.cost_items"
                :key="`cost_${index}`"
                class="px-1"
              >
                <b-col
                  cols="12"
                  class="d-flex backgroundColor3 mb-1 radius-round border-1"
                >
                  <b-row class="flex-grow-1 p-2">
                    <b-col cols="12" md="6">
                      <b-row>
                        <b-col cols="12">
                          <b-form-group
                            :label="`商品分類：`"
                            :label-for="`product_category_id${index}`"
                            label-cols-md="2"
                          >
                            <v-select
                              v-model="cost.product_category_id"
                              :dir="
                                $store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                              "
                              :options="productCategoriesOptions"
                              :filter="productCategorySearch"
                              :clearable="false"
                              label="name"
                              :reduce="(option) => option.id"
                              placeholder="選擇商品分類"
                              @input="(val) => filterProductByCategory(cost)"
                            >
                            </v-select>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12">
                          <b-form-group
                            :label="`商品(${index + 1})：`"
                            :label-for="`product_id${index}`"
                            label-cols-md="2"
                          >
                            <v-select
                              v-model="cost.product_id"
                              :dir="
                                $store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                              "
                              :options="cost.productOptions"
                              :filter="productSearch"
                              :clearable="false"
                              label="product_name"
                              :reduce="(option) => option.id"
                              :placeholder="
                                cost.product_category_id == 13
                                  ? '請在備註填寫'
                                  : '選擇商品分類內的項目'
                              "
                              :disabled="cost.product_category_id == 13"
                              @input="(val) => updateSelectedProduct(cost, val)"
                            >
                            </v-select>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12">
                          <b-row class="mb-1 cal-input-group">
                            <b-col md="2" class="label">
                              金額:<span class="colorRed">*</span>
                            </b-col>
                            <b-col md="10" class="c_content">
                              <div
                                class="content-wrapper d-flex align-items-center"
                              >
                                <b-input-group
                                  class="group1"
                                  size="md"
                                  :append="getProduct(cost.product_id).unit"
                                >
                                  <b-form-input
                                    id="cost-quantity"
                                    step="any"
                                    type="number"
                                    v-model="cost.quantity"
                                    placeholder="輸入數量"
                                    @input="calTotalCost(cost)"
                                  />
                                  <!-- @input="(val) => calculatePostponeDate(val)" -->
                                </b-input-group>
                                <div class="operator">*</div>
                                <b-input-group
                                  class="group2"
                                  size="md"
                                  prepend="$"
                                  :append="`每${
                                    getProduct(cost.product_id).unit
                                  }`"
                                >
                                  <b-form-input
                                    :id="`cost_unit_price${index}`"
                                    v-model="cost.unit_price"
                                    placeholder="輸入單價"
                                    @input="calTotalCost(cost)"
                                  />
                                </b-input-group>
                                <div class="operator">=</div>
                                <b-input-group
                                  class="group3"
                                  size="md"
                                  prepend="$"
                                >
                                  <b-form-input
                                    id=""
                                    class="cost_amount"
                                    disabled
                                    type="number"
                                    v-model="cost.amount"
                                    placeholder="輸入總金額"
                                  />
                                </b-input-group>
                              </div>
                            </b-col>
                          </b-row>
                        </b-col>
                        <div
                          class="colorRed mt-1"
                          v-if="
                            !cost.quantity || !cost.unit_price || !cost.amount
                          "
                        >
                          <div class="mr-50" v-if="!cost.quantity">
                            請輸入數量
                          </div>
                          <div class="mr-50" v-if="!cost.unit_price">
                            請輸入單價
                          </div>
                          <!-- <div class="mr-50" v-if="!cost.amount">
                            請輸入總金額
                          </div> -->
                        </div>
                      </b-row>
                    </b-col>
                    <b-col cols="12" md="6">
                      <b-row>
                        <b-col cols="12">
                          <b-form-group
                            label="增加空行數量"
                            label-for="empty_rows"
                            label-cols-md="2"
                          >
                            <b-form-input
                              type="number"
                              v-model="cost.empty_rows"
                              placeholder="輸入增加空行數量"
                            />
                          </b-form-group>
                        </b-col>
                        <!-- <b-col cols="12">
                        <b-form-group
                        label="尺寸："
                        label-for="size"
                        label-cols-md="2"
                      >
                        <b-form-input
                          id="size"
                          v-model="cost.size"
                          placeholder="輸入尺寸"
                        />
                      </b-form-group>
                      </b-col> -->
                        <!-- item_description -->
                        <b-col cols="12">
                          <!-- <validation-provider
                            #default="validationContext"
                            :vid="`v-cost-item_description${index}`"
                            name="備註"
                            rules="required"
                          > -->
                          <b-form-group
                            label="備註/尺寸："
                            :label-for="`cost-item_description${index}`"
                            label-cols-md="2"
                          >
                            <!-- class="required"
                                :state="getValidationState(validationContext)" -->
                            <b-form-textarea
                              :id="`cost-item_description${index}`"
                              v-model="cost.item_description"
                              rows="4"
                              placeholder="輸入備註/尺寸"
                            />
                            <!-- <b-form-invalid-feedback>
                                {{ validationContext.errors[0] }}
                              </b-form-invalid-feedback> -->
                          </b-form-group>
                          <!-- </validation-provider> -->
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <div
                    class="d-flex flex-column justify-content-between py-50 px-25"
                  >
                    <feather-icon
                      size="16"
                      icon="PlusIcon"
                      class="cursor-pointer text-success"
                      @click="addItem('cost_items', index)"
                    />
                    <feather-icon
                      size="16"
                      icon="XIcon"
                      class="cursor-pointer text-danger"
                      @click="removeItem('cost_items', index, cost.id)"
                    />
                  </div>
                </b-col>
              </b-row>
            </div>
            <hr
              v-if="
                $route.name == 'invoice-create' && !$route.query.quotation_id
              "
            />
            <b-row>
              <b-col
                cols="12"
                md="6"
                v-if="
                  ($route.name == 'invoice-create' &&
                    !$route.query.quotation_id) ||
                  $route.name == 'invoice-copy'
                "
              >
                <div class="d-flex align-items-center">
                  <div class="label-title">
                    <span>優惠卷：</span>
                  </div>
                  <v-select
                    id="coupon_id"
                    class="flex-1"
                    v-model="newInvoiceData.coupon_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="couponOptions"
                    :filter="couponSearch"
                    :clearable="true"
                    label="name"
                    :reduce="(option) => option.id"
                    placeholder="選擇優惠卷"
                  >
                    <template
                      #option="{ code, amount, percentage, total_amount }"
                    >
                      [{{ code }}]
                      {{ amount ? "$" + amount : percentage + "%" }}折扣{{
                        Number(total_amount)
                          ? ` (優惠券生效前必須達到${total_amount})`
                          : ""
                      }}
                    </template>
                    <template
                      #selected-option="{
                        code,
                        amount,
                        percentage,
                        total_amount,
                      }"
                    >
                      [{{ code }}]
                      {{ amount ? "$" + amount : percentage + "%" }}折扣{{
                        Number(total_amount)
                          ? ` (優惠券生效前必須達到${total_amount})`
                          : ""
                      }}
                    </template>
                  </v-select>
                </div>
                <span
                  class="colorRed"
                  v-if="
                    getCoupon(newInvoiceData.coupon_id) &&
                    getCoupon(newInvoiceData.coupon_id).total_amount &&
                    getCoupon(newInvoiceData.coupon_id).total_amount >
                      newInvoiceData.amount
                  "
                >
                  你的金額未達到要求
                </span>
              </b-col>
              <b-col
                cols="12"
                md="6"
                v-if="
                  ($route.name == 'invoice-create' &&
                    !$route.query.quotation_id) ||
                  $route.name == 'invoice-copy'
                "
              >
                <div class="d-flex align-items-center">
                  <div class="label-title">
                    <span>購物禮卷：</span>
                  </div>
                  <v-select
                    id="gift_voucher_id"
                    class="flex-1"
                    v-model="newInvoiceData.gift_voucher_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="giftOptions"
                    :filter="giftSearch"
                    :clearable="false"
                    label="name"
                    :reduce="(option) => option.id"
                    placeholder="選擇購物禮卷"
                  >
                    <template #option="{ code, amount }">
                      [{{ code }}] {{ amount }}
                    </template>
                    <template #selected-option="{ code, amount }">
                      [{{ code }}] {{ amount }}
                    </template>
                  </v-select>
                </div>
              </b-col>
              <b-col cols="12">
                <hr />
              </b-col>
              <!-- <b-col cols="12" md="6">
                <b-form-group
                  label="第一次付款金額："
                  label-for="deposit_amount"
                  label-cols-md="3"
                >
                  <b-form-input
                    id="deposit_amount"
                    v-model="newInvoiceData.deposit_amount"
                    placeholder="輸入第一次付款金額"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  label="第一次付款截止日期："
                  label-for="deposit_due_date"
                  label-cols-md="3"
                >
                  <flat-pickr
                    v-model="newInvoiceData.deposit_due_date"
                    :config="{
                      allowInput: true,
                      altInput: true,
                      altFormat: 'Y-m-d',
                      dateFormat: 'Y-m-d',
                    }"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6" v-if="newInvoiceData.id > 0">
                <b-form-group
                  label="第一次付款支付日期："
                  label-for="deposit_paid_date"
                  label-cols-md="3"
                >
                  <flat-pickr
                    v-model="newInvoiceData.deposit_paid_date"
                    :config="{
                      allowInput: true,
                      altInput: true,
                      altFormat: 'Y-m-d',
                      dateFormat: 'Y-m-d',
                    }"
                  />
                </b-form-group>
              </b-col> -->

              <div class="w-100">
                <div
                  class="d-flex justify-content-between align-items-center mb-2"
                >
                  <h5 class="my-2 mb-1">階段付款</h5>
                  <b-button
                    v-if="!(newInvoiceData.payment_steps && newInvoiceData.payment_steps.length)"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    @click="addItem('payment_steps', 0)"
                    size="sm"
                  >
                    <feather-icon size="16" icon="PlusCircleIcon" />
                  </b-button>
                </div>
                <div class="mb-2">
                  <small
                    :class="{
                      'text-success': isPercentageValid,
                      'text-danger': !isPercentageValid,
                    }"
                  >
                    佔比總和：{{ totalPercentage }}%
                    <span v-if="!isPercentageValid"> （必須等於 100%） </span>
                  </small>
                </div>
                <div>
                  <!-- <validation-provider
                        #default="validationContext"
                        name="此欄"
                        rules="required"
                        `vid="step_title${index}`"
                      > -->
                  <b-form-group
                    :label="`主題：`"
                    label-for="payment_steps_title"
                  >
                    <!-- class="required" -->
                    <b-form-input
                      id="payment_steps_title"
                      v-model="newInvoiceData.payment_steps_title"
                      placeholder="輸入主題"
                    />
                  </b-form-group>
                  <!--
                      :state="getValidationState(validationContext)" <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider> -->
                </div>
                <hr />
                <b-row
                  v-for="(step, index) in newInvoiceData.payment_steps"
                  :key="`step_${index}`"
                  class="px-1"
                >
                  <b-col
                    cols="12"
                    class="d-flex backgroundColor3 mb-1 radius-round border-1"
                  >
                    <b-row class="flex-grow-1 p-2">
                      <b-col cols="12" md="6">
                        <validation-provider
                          #default="validationContext"
                          name="此欄"
                          rules="required"
                          :vid="`v_step_phase${index}`"
                        >
                          <b-form-group
                            :label="`階段：`"
                            :label-for="`step_phase${index}`"
                            label-cols-md="3"
                            class="required"
                          >
                            <v-select
                              :id="`receipt-description-select${index}`"
                              v-model="step.step_phase"
                              :dir="
                                $store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                              "
                              :options="receiptDescriptionOptions"
                              :clearable="true"
                              label="description"
                              :reduce="(option) => option.description"
                              placeholder="選擇階段"
                              :filter="receiptDescriptionSearch"
                            >
                              <template #option="{ description }">
                                {{ description }}
                              </template>
                              <template #selected-option="{ description }">
                                {{ description }}
                              </template>
                            </v-select>
                          </b-form-group>
                          <b-form-invalid-feedback
                            :state="getValidationState(validationContext)"
                          >
                            {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                        </validation-provider>
                      </b-col>
                      <b-col cols="12" md="6">
                        <validation-provider
                          #default="validationContext"
                          name="此欄"
                          rules="required"
                          :vid="`v_step_percentage${index}`"
                        >
                          <b-form-group
                            :label="`佔比：`"
                            :label-for="`step_percentage${index}`"
                            label-cols-md="3"
                            class="required"
                          >
                            <b-input-group class="group1" size="md" append="%">
                              <b-form-input
                                :id="`step_percentage${index}`"
                                v-model="step.step_percentage"
                                type="number"
                                step="any"
                                min="0"
                                max="100"
                                placeholder="輸入佔比"
                                :state="getValidationState(validationContext)"
                                @input="
                                  handlePaymentStepPercentageChange(step, index)
                                "
                              />
                            </b-input-group>
                          </b-form-group>
                          <b-form-invalid-feedback>
                            {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                        </validation-provider>
                      </b-col>
                      <b-col cols="12" md="6">
                        <!-- <validation-provider
                          #default="validationContext"
                          name="此欄"
                          rules="required"
                          :vid="`v_step_amount${index}`"
                        > -->
                        <b-form-group
                          :label="`金額：`"
                          :label-for="`step_amount${index}`"
                          label-cols-md="3"
                        >
                          <!-- class="required" -->
                          <b-input-group
                            class="group-muted"
                            size="md"
                            prepend="$"
                          >
                            <b-form-input
                              :id="`step_amount${index}`"
                              v-model="step.step_amount"
                              type="number"
                              step="any"
                              placeholder="自動計算金額"
                              readonly
                            />
                            <!-- :state="getValidationState(validationContext)" -->
                          </b-input-group>
                        </b-form-group>
                        <!-- <b-form-invalid-feedback>
                            {{ validationContext.errors[0] }}
                          </b-form-invalid-feedback>
                        </validation-provider> -->
                      </b-col>
                      <b-col cols="12" md="6">
                        <b-form-group
                          :label="`備註：`"
                          :label-for="`step_name${index}`"
                          label-cols-md="3"
                        >
                          <b-form-input
                            :id="`step_name${index}`"
                            v-model="step.step_name"
                            placeholder="輸入備註"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <div
                      class="d-flex flex-column justify-content-between py-50 px-25"
                    >
                      <feather-icon
                        size="16"
                        icon="PlusIcon"
                        class="cursor-pointer text-success"
                        @click="addItem('payment_steps', index)"
                      />
                      <feather-icon
                        size="16"
                        icon="XIcon"
                        class="cursor-pointer text-danger"
                        @click="removeItem('payment_steps', index, step.id)"
                      />
                    </div>
                  </b-col>
                </b-row>
              </div>

              <!-- remark -->

              <b-col cols="12" md="12">
                <hr />
                <div>單據備註：</div>
                <b-form-group label="" label-for="remark_id">
                  <v-select
                    id="remark_id"
                    v-model="newInvoiceData.invoice_description_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="invoiceDescriptionOptions"
                    :filter="invoiceDescriptionSearch"
                    :clearable="true"
                    label="name"
                    :reduce="(option) => option.id"
                    placeholder="選擇單據備註"
                    :disabled="!ability.can('invoice_remark', 'invoice_form')"
                    :readonly="!ability.can('invoice_remark', 'invoice_form')"
                  >
                  </v-select>
                </b-form-group>
                <b-form-group label="" label-for="remark">
                  <b-form-textarea
                    id="remark"
                    v-model="newInvoiceData.remark"
                    placeholder="輸入單據備註"
                    autofocus
                    trim
                    class="textarea"
                    :key="`remark${trigger}`"
                    :disabled="!ability.can('invoice_remark', 'invoice_form')"
                    :readonly="!ability.can('invoice_remark', 'invoice_form')"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="8"></b-col>
              <b-col cols="4" class="amount-block">
                <b-row class="">
                  <!-- amount -->
                  <b-col cols="12">
                    <validation-provider
                      #default="validationContext"
                      name="總額"
                      rules="required"
                    >
                      <b-form-group
                        label="總額："
                        label-for="amount"
                        label-cols-md="4"
                      >
                        <b-form-input
                          id="invoice_amount"
                          v-model="newInvoiceData.amount"
                          placeholder="輸入總額"
                          :disabled="true"
                        />
                        <b-form-invalid-feedback>
                          {{ validationContext.errors[0] }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <!-- coupon_info -->
                  <b-col cols="12">
                    <b-form-group
                      :label="`優惠卷${
                        coupon_info.title
                          ? '(' +
                            coupon_info.title +
                            ' ' +
                            (coupon_info.percentage
                              ? coupon_info.percentage + '%'
                              : '') +
                            ')'
                          : ''
                      }折扣：`"
                      label-for="coupon_info"
                      label-cols-md="4"
                    >
                      <b-form-input
                        id="coupon_info"
                        v-model="coupon_info.amount"
                        placeholder="輸入優惠卷折扣"
                        :disabled="true"
                      />
                    </b-form-group>
                  </b-col>
                  <!-- gift_info -->
                  <b-col cols="12">
                    <b-form-group
                      :label="`購物禮卷${
                        gift_info.code ? '(' + gift_info.code + ')' : ''
                      }折扣：`"
                      label-for="gift_info"
                      label-cols-md="4"
                    >
                      <b-form-input
                        id="gift_info"
                        v-model="gift_info.amount"
                        placeholder="輸入購物禮卷折扣"
                        :disabled="true"
                      />
                    </b-form-group>
                  </b-col>
                  <!-- total_amount -->
                  <b-col cols="12">
                    <b-form-group
                      label="發票總額："
                      label-for="total_amount"
                      label-cols-md="4"
                    >
                      <b-form-input
                        id="total_amount"
                        v-model="total_amount"
                        placeholder="輸入報價單總額"
                        :disabled="true"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12">
                <hr />
              </b-col>
              <!-- company stamp -->
              <!-- <b-col cols="12" md="6">
                <b-form-group
                  label="公司印章："
                  label-for="stamp_id"
                  label-cols-md="3"
                >
                  <b-form-checkbox
                    :checked="newInvoiceData.stamp"
                    name="stamp"
                    switch
                    inline
                    v-model="newInvoiceData.stamp"
                    value="1"
                    style="margin-top: 5px"
                  >
                    {{ newInvoiceData.stamp ? "有" : "無" }}
                  </b-form-checkbox>
                </b-form-group>
              </b-col> -->
              <!-- template id -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="模版"
                  rules="required"
                >
                  <b-form-group
                    label="選擇模版："
                    label-for="stamp"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="stamp"
                      v-model="newInvoiceData.template_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="templateOptions"
                      :filter="templateSearch"
                      :clearable="false"
                      label="template_name"
                      :reduce="(option) => option.id"
                      placeholder="選擇模版"
                      @input="changeTemplate"
                    >
                    </v-select>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- stamp_id -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="選擇印章："
                  label-for="stamp"
                  label-cols-md="3"
                >
                  <v-select
                    id="stamp"
                    v-model="newInvoiceData.stamp_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="stampOptions"
                    :filter="stampSearch"
                    :clearable="true"
                    label="name"
                    :reduce="(option) => option.id"
                    placeholder="選擇印章"
                  >
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <hr />
              </b-col>
            </b-row>
            <div>
              <b-row
                class="d-flex mb-1 justify-content-between align-items-center"
              >
                <b-col class="mb-1 mb-sm-0" cols="12" md="6">
                  <div class="mb-5">客戶蓋章或簽署：</div>
                  <br />
                  <div class="d-flex align-items-center">
                    <span class="text-nowrap">日期：</span
                    ><flat-pickr
                      v-model="newInvoiceData.date1"
                      class="form-control just-line bg-white"
                      :disabled="true"
                      :config="{
                        allowInput: true,
                        altInput: true,
                        altFormat: 'Y-m-d',
                        dateFormat: 'Y-m-d',
                      }"
                    />
                  </div>
                </b-col>
                <b-col class="mb-1 mb-sm-0" cols="12" md="6">
                  <div class="">永發設計工程有限公司</div>
                  <div class="mb-5">公司蓋章或簽署：</div>
                  <div class="d-flex align-items-center">
                    <span class="text-nowrap">日期：</span>
                    <flat-pickr
                      v-model="newInvoiceData.date2"
                      class="form-control just-line bg-white"
                      :disabled="true"
                      :config="{
                        allowInput: true,
                        altInput: true,
                        altFormat: 'Y-m-d',
                        dateFormat: 'Y-m-d',
                      }"
                    />
                  </div>
                </b-col>
              </b-row>
              <div class="mt-3">
                <div>備註：</div>
                <b-form-group label="" label-for="remark_id">
                  <v-select
                    id="remark_id"
                    v-model="newInvoiceData.remark_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="pdfRemarkOptions"
                    :filter="pdfRemarkSearch"
                    :clearable="true"
                    label="title"
                    :reduce="(option) => option.id"
                    placeholder="選擇備註"
                    :disabled="
                      !ability.can('pdf_remark', 'invoice_form')
                    "
                    :readonly="
                      !ability.can('pdf_remark', 'invoice_form')
                    "
                  >
                  </v-select>
                </b-form-group>
                <b-form-group label="" label-for="invoice_remark">
                  <b-form-textarea
                    id="invoice_remark"
                    v-model="newInvoiceData.invoice_remark"
                    placeholder="備註"
                    autofocus
                    trim
                    class="textarea"
                    :key="`invoice_remark_${trigger}`"
                    :disabled="
                      !ability.can('pdf_remark', 'invoice_form')
                    "
                    :readonly="
                      !ability.can('pdf_remark', 'invoice_form')
                    "
                  />
                </b-form-group>
                <hr />
                <b-row>
                  <b-col cols="12"> 地址:{{ info.address }} </b-col>
                  <b-col cols="12" md="6"> 網址:{{ info.website }}</b-col>
                  <b-col cols="12" md="6"> 電話: {{ info.phone }}</b-col>
                  <b-col cols="12" md="6"> 電郵: {{ info.email }} </b-col>
                  <b-col cols="12" md="6"> 傳真:{{ info.fax }} </b-col>
                </b-row>
              </div>
            </div>
            <div
              class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-sm-2 mobile-w100"
                type="submit"
              >
                <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
                提交
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
                class="mt-1 mt-sm-0 mobile-w100"
              >
                取消
              </b-button>
            </div>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BOverlay,
  BSpinner,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, watch, onMounted, computed, nextTick } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email } from "@validations";
import { getDateTime } from "@/libs/helper";
import ability from "@/libs/acl/ability";

export default {
  data() {
    return {
      required,
      email,
      ability,
      initial: true,
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormTextarea,
    BInputGroup,
    BInputGroupAppend,
    BRow,
    BCol,
    BButton,
    BOverlay,
    BSpinner,
    flatPickr,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  methods: {
    projectSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return (
          item.project_name.toLowerCase().includes(search.toLowerCase()) ||
          item.project_number.toLowerCase().includes(search.toLowerCase())
        );
      });
      return returnOptions;
    },
    receiptDescriptionSearch(options, search) {
      return options.filter((item) => {
        return item.description.toLowerCase().includes(search.toLowerCase());
      });
    },
    customerSearch(options, search) {
      return options.filter((item) => {
        return item.name_cn.toLowerCase().includes(search.toLowerCase());
      });
    },
    productCategorySearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },
    productSearch(options, search) {
      return options.filter((item) => {
        return item.product_name.toLowerCase().includes(search.toLowerCase());
      });
    },
    couponSearch(options, search) {
      return options.filter((item) => {
        return item.title.toLowerCase().includes(search.toLowerCase());
      });
    },
    giftSearch(options, search) {
      return options.filter((item) => {
        return item.title.toLowerCase().includes(search.toLowerCase());
      });
    },
    invoiceDescriptionSearch(options, search) {
      return options.filter((item) => {
        return item.title.toLowerCase().includes(search.toLowerCase());
      });
    },
    templateSearch(options, search) {
      return options.filter((item) => {
        return item.template_name.toLowerCase().includes(search.toLowerCase());
      });
    },
    stampSearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },
    pdfRemarkSearch(options, search) {
      return options.filter((item) => {
        return item.title.toLowerCase().includes(search.toLowerCase());
      });
    },
    hide() {
      this.$router.replace("/invoices/list");
    },
    filterProductByCategory(cost) {
      //console.log("cost", cost);
      cost.product_id = null;
      cost.productOptions = this.productOptions.filter(
        (product) => product.product_category_id == cost.product_category_id
      );
    },
    quotationSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return (
          item.quotation_number.toLowerCase().includes(search.toLowerCase()) ||
          item.name_cn.toLowerCase().includes(search.toLowerCase())
        );
      });
      return returnOptions;
    },
    changeNextLine(str) {
      // 處理不同的資料類型
      if (!str) {
        return "";
      }

      // 如果是字串，直接處理
      if (typeof str === "string") {
        return str.replace(/\n/g, "<br>");
      }

      // 如果是物件且有 content 屬性（例如備註物件）
      if (typeof str === "object" && str.content) {
        return typeof str.content === "string"
          ? str.content.replace(/\n/g, "<br>")
          : "";
      }

      // 如果是物件且有 title 屬性
      if (typeof str === "object" && str.title) {
        return typeof str.title === "string"
          ? str.title.replace(/\n/g, "<br>")
          : "";
      }

      // 如果是數字或其他原始類型，轉換為字串
      if (typeof str === "number" || typeof str === "boolean") {
        return String(str);
      }

      // 如果是陣列，嘗試連接元素
      if (Array.isArray(str)) {
        return str
          .map((item) =>
            typeof item === "string"
              ? item
              : typeof item === "object" && item.content
              ? item.content
              : String(item)
          )
          .join("<br>");
      }

      // 其他情況，嘗試轉換為字串
      try {
        const stringValue = String(str);
        return stringValue !== "[object Object]" ? stringValue : "";
      } catch (error) {
        console.warn("changeNextLine: 無法處理的資料類型", str);
        return "";
      }
    },
    checkVaild() {
      if (this.newInvoiceData.cost_items.length <= 0) {
        this.makeToast("danger", "Warning", "請輸入最少一個成本記錄。");
        return false;
      } else if (!this.newInvoiceData.payment_steps || this.newInvoiceData.payment_steps.length <= 0) {
        this.makeToast("danger", "Warning", "請輸入最少一個階段付款記錄。");
        return false;
      } else {
        // 驗證 payment_steps 佔比總和
        const percentageValidation = this.validatePaymentStepPercentages();
        if (!percentageValidation.isValid) {
          this.makeToast("danger", "Warning", percentageValidation.message);
          return false;
        }
        return true;
      }
    },
    async onSubmit() {
      if (!this.checkVaild()) {
        return;
      }

      // 在提交前再次驗證發票編號唯一性
      await this.validateInvoiceNumber();

      // 檢查發票編號唯一性驗證結果
      if (!this.invoiceNumberValidation.isValid) {
        this.makeToast("danger", "Warning", "發票編號已存在，請使用其他編號");
        return;
      }

      this.newInvoiceData.cost_items.forEach((item, index) => {
        item.item_description = this.changeNextLine(item.item_description);
        item.sort_order = index + 1;
        item.empty_rows = item.empty_rows || 0;
      });

      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;

          store
            .dispatch("invoice/editInvoice", this.newInvoiceData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.hide();
              // this.$emit("refetch-data");
              // if (this.newInvoiceData.id == 0) {
              //   this.newInvoiceData.id = response.data.id;
              //   this.redirect(response.data.id);
              // }
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },

    addItem(key, index) {
      let newItem;

      if (key === "payment_steps") {
        newItem = JSON.parse(
          JSON.stringify({
            id: 0,
            step_phase: "",
            step_name: "",
            step_percentage: 0,
            step_amount: 0,
          })
        );
      } else {
        newItem = JSON.parse(
          JSON.stringify({
            id: 0,
            empty_rows: 0,
          })
        );
      }

      if (index !== undefined) {
        this.newInvoiceData[key].splice(index + 1, 0, newItem);
      } else {
        this.newInvoiceData[key].push(newItem);
      }
    },
    removeItem(key, index, id) {
      // check number of record
      let record =
        this.newInvoiceData &&
        this.newInvoiceData[key] &&
        this.newInvoiceData[key].length;
      if (record <= 1) {
        this.makeToast("danger", "Warning", "請至少留有一個表單。");
      } else {
        // 檢查是否為成本項目且發票已有付款記錄
        if (key === 'cost_items' && id > 0 && this.newInvoiceData.total_paid > 0) {
          this.makeToast(
            "danger",
            "無法刪除",
            "此發票已有付款記錄，無法刪除成本項目。如需修改，請先處理相關收據。"
          );
          return;
        }

        // if (id > 0) {
        //   this.$swal({
        //     title: "你確定嗎?",
        //     text: "您的行動是最終的，您將無法檢索這記錄。",
        //     showCancelButton: true,
        //     confirmButtonText: "刪除",
        //     cancelButtonText: "取消",
        //     customClass: {
        //       confirmButton: "btn btn-primary",
        //       cancelButton: "btn btn-outline-danger ml-1",
        //     },
        //     buttonsStyling: false,
        //   }).then((result) => {
        //     if (result.value) {
        //       let url = "deleteInvoiceSalary";
        //       if (key == "cost_items") url = "deleteInvoiceCost";
        //       store
        //         .dispatch(`invoice/${url}`, { id })
        //         .then((response) => {
        //           this.$swal({
        //             text: response.data.message,
        //             icon: "success",
        //             confirmButtonText: "確定",
        //             customClass: {
        //               confirmButton: "btn btn-primary",
        //             },
        //             showClass: {
        //               popup: "animate__animated animate__bounceIn",
        //             },
        //             buttonsStyling: false,
        //           });
        //           this.$emit("refetch-data");
        //         })
        //         .catch((error) => {
        //           this.$swal({
        //             text: error.response.data.message,
        //             icon: "error",
        //             confirmButtonText: "確定",
        //             customClass: {
        //               confirmButton: "btn btn-primary",
        //             },
        //             showClass: {
        //               popup: "animate__animated animate__bounceIn",
        //             },
        //             buttonsStyling: false,
        //           });
        //         });
        //     }
        //   });
        // } else {
        this.newInvoiceData[key].splice(index, 1);
        // }
      }

      this.calTotalAmount();
    },
    handleInvoiceTypeChange() {
      if (this.newInvoiceData.invoice_type_id == 1) {
        this.newInvoiceData.remark_id = 2;
      } else {
        this.newInvoiceData.remark_id = 4;
      }
      // if (
      //     this.pdfRemarkOptions &&
      //     this.pdfRemarkOptions.length > 0
      //   ){
      //     this.newInvoiceData.invoice_remark =
      //       this.pdfRemarkOptions.filter(
      //         (ele) => ele.id == this.newInvoiceData.remark_id
      //       )[0].content;
      //       this.$forceUpdate();
      // }
    },
  },
  props: {
    invoiceData: {
      type: Object,
      required: true,
    },
    quotationOptions: {
      type: Array,
      required: true,
    },
    invoiceTypeOptions: {
      type: Array,
      required: true,
    },
    projectOptions: {
      type: Array,
      required: true,
    },
    customerOptions: {
      type: Array,
      required: true,
    },
    productOptions: {
      type: Array,
      required: true,
    },
    productCategoriesOptions: {
      type: Array,
      required: true,
    },
    receiptDescriptionOptions: {
      type: Array,
      required: true,
    },
    invoiceDescriptionOptions: {
      type: Array,
      required: true,
    },
    pdfRemarkOptions: {
      type: Array,
      required: true,
    },
    templateOptions: {
      type: Array,
      required: true,
    },
    stampOptions: {
      type: Array,
      required: true,
    },
  },
  watch: {
    newInvoiceData: {
      handler() {
        if (this.newInvoiceData.amount) {
          if (
            router.currentRoute.name == "invoice-create" ||
            router.currentRoute.name == "invoice-copy"
          ) {
            if (!router.currentRoute.query.quotation_id) {
              if (this.newInvoiceData.coupon_id) {
                this.coupon_info.title = this.getCoupon(
                  this.newInvoiceData.coupon_id
                ).title;

                if (
                  this.getCoupon(this.newInvoiceData.coupon_id).total_amount
                ) {
                  if (
                    this.newInvoiceData.amount <
                    this.getCoupon(this.newInvoiceData.coupon_id).total_amount
                  ) {
                    this.coupon_info.amount = 0;
                  } else {
                    if (this.getCoupon(this.newInvoiceData.coupon_id).amount) {
                      this.coupon_info.amount = this.getCoupon(
                        this.newInvoiceData.coupon_id
                      ).amount;
                    } else {
                      this.coupon_info.amount =
                        this.newInvoiceData.amount *
                        (this.getCoupon(this.newInvoiceData.coupon_id)
                          .percentage /
                          100);

                      this.coupon_info.percentage = this.getCoupon(
                        this.newInvoiceData.coupon_id
                      ).percentage;
                    }
                  }
                }
              } else {
                this.coupon_info.title = null;
                this.coupon_info.amount = 0;
              }

              if (this.newInvoiceData.gift_voucher_id) {
                this.gift_info.code = this.getGift(
                  this.newInvoiceData.gift_voucher_id
                ).title;
                this.gift_info.amount = this.getGift(
                  this.newInvoiceData.gift_voucher_id
                ).amount;
              } else {
                this.gift_info.code = null;
                this.gift_info.amount = 0;
              }
            } else {
              if (
                this.newInvoiceData.coupon_record &&
                this.newInvoiceData.coupon_record.percentage
              ) {
                this.coupon_info.amount =
                  (this.newInvoiceData.amount *
                    this.newInvoiceData.coupon_record.percentage) /
                  100;
              }
            }
          }
          if (
            this.newInvoiceData.coupon_record &&
            this.newInvoiceData.coupon_record.percentage
          ) {
            this.coupon_info.amount =
              (this.newInvoiceData.amount *
                this.newInvoiceData.coupon_record.percentage) /
              100;
          }
          this.total_amount =
            Number(this.newInvoiceData.amount) -
            Number(this.coupon_info.amount) -
            Number(this.gift_info.amount);

          this.total_amount =
            this.total_amount > 0
              ? Math.round(this.total_amount * 100) / 100
              : 0;

          if (this.initial) {
            this.newInvoiceData.cost_items.forEach((item) => {
              item.productOptions = this.productOptions.filter(
                (product) =>
                  product.product_category_id == item.product_category_id
              );
            });
            this.initial = false;
          }
        }
      },
      deep: true,
    },
  },

  setup(props, { emit }) {
    const newInvoiceData = ref({
      id: 0,
      stamp: 1,
      invoice_number: null,
      invoice_number_remark: "",
      cost_items: [
        {
          id: 0,
          amount: 0,
          invoice_id: null,
          item_description: "",
          product: null,
          product_category_id: null,
          product_id: null,
          quantity: 0,
          sort_order: 1,
          total_amount: 0,
          unit_price: 0,
        },
      ],
      amount: 0,
      quotation_id: null,
      project_id: null,
      coupon_id: null,
      gift_voucher_id: null,
      project_name: null,
      address: null,
      payment_steps: [
        {
          id: 0,
          step_phase: "",
          step_name: "",
          step_percentage: 0,
          step_amount: 0,
        },
      ],
      payment_steps_title: "",
      invoice_description_id: null,
      remark: "",
      remark_id: null,
      invoice_remark: "",
    });

    const trigger = ref(false);
    // const showCostItems = ref(false);
    const isInit = ref(true);

    // payment_steps_title 現在直接使用 newInvoiceData.payment_steps_title
    const isInitProject = ref(true);
    const isInitQuotation = ref(true);
    const isInitInvoiceDescription = ref(true);
    const isInitInvoiceRemark = ref(true);
    const isInitInvoiceRemarkId = ref(true);
    const loadingInvoiceNumber = ref(false);
    const invoiceNumberValidation = ref({
      message: "",
      isValid: true,
    });

    const coupon_info = ref({
      title: null,
      amount: 0,
      percentage: 0,
    });
    const gift_info = ref({
      code: null,
      amount: 0,
    });
    const total_amount = ref(0);

    const info = ref({
      website: null,
      address: null,
      phone: null,
      fax: null,
      email: null,
    });

    const changeTemplate = (id) => {
      let template =
        props.templateOptions &&
        props.templateOptions.length > 0 &&
        props.templateOptions.find((ele) => ele.id == id);
      info.value.website = template.website;
      info.value.address = template.address;
      info.value.phone = template.phone;
      info.value.fax = template.fax;
      info.value.email = template.email;
    };

    const isFirstLoadCustomer = ref(true);
    const isFirstLoadQuotation = ref(true);

    watch(
      () => newInvoiceData.value.customer_id,
      (newVal, oldVal) => {
        if (
          router.currentRoute.name === "invoice-edit" &&
          isFirstLoadCustomer.value
        ) {
          isFirstLoadCustomer.value = false;
          return;
        }

        if (router.currentRoute.name != "invoice-edit") {
          resetCoupon();
          getUserCoupon(newInvoiceData.value.customer_id);
        }

        if (
          (router.currentRoute.query.quotation_id ||
            router.currentRoute.name == "invoice-copy") &&
          isInit.value
        ) {
          isInit.value = false;
          return;
        }

        if (props.customerOptions && props.customerOptions.length > 0) {
          const customer = props.customerOptions.filter(
            (ele) => ele.id == newVal
          )[0];

          newInvoiceData.value.quotation_id = null;
          newInvoiceData.value.project_id = null;
          newInvoiceData.value.project_name = null;
          newInvoiceData.value.address = null;

          if (customer) {
            newInvoiceData.value.name_cn = customer.name_cn;
            newInvoiceData.value.name_en = customer.name;
            newInvoiceData.value.mobile = customer.phone;
            newInvoiceData.value.email = customer.email;
          }
        }
      }
    );

    watch(
      () => newInvoiceData.value.quotation_id,
      (newVal, oldVal) => {
        // 只在edit頁面首次載入時不執行
        if (
          router.currentRoute.name === "invoice-edit" &&
          isFirstLoadQuotation.value
        ) {
          //console.log("skipping first load in edit");
          isFirstLoadQuotation.value = false;
          return;
        }

        // 之後所有的quotation_id變更都會執行以下邏輯
        if (!newVal) {
          //console.log("clearing quotation data");
          newInvoiceData.value.project_name = null;
          newInvoiceData.value.address = null;
          newInvoiceData.value.cost_items = [{ id: 0 }];
          newInvoiceData.value.invoice_type_id = null;
          newInvoiceData.value.amount = null;
          return;
        }

        if (props.quotationOptions && props.quotationOptions.length > 0) {
          //console.log("updating quotation data");
          const data = props.quotationOptions.find((ele) => ele.id == newVal);
          if (data) {
            newInvoiceData.value.project_name = data.project_name;
            newInvoiceData.value.address = data.address;
            newInvoiceData.value.invoice_type_id = data.quotation_type_id;
            newInvoiceData.value.cost_items = data.cost_items.map((item) => {
              item.id = 0;
              return item;
            });
            newInvoiceData.value.amount = data.amount;

            // 根據發票類別設定正確的 remark_id（不要直接複製報價單的 remark_id）
            if (data.quotation_type_id == 1) {
              // 銷售類發票
              newInvoiceData.value.remark_id = 2;
            } else {
              // 維修類發票
              newInvoiceData.value.remark_id = 4;
            }

            // 確保 payment_steps 欄位存在（報價單沒有此欄位，需要為發票初始化）
            if (!newInvoiceData.value.payment_steps || !Array.isArray(newInvoiceData.value.payment_steps)) {
              newInvoiceData.value.payment_steps = [
                {
                  id: 0,
                  step_phase: "",
                  step_name: "",
                  step_percentage: 0,
                  step_amount: 0,
                }
              ];
            }

            // 確保 payment_steps_title 欄位存在
            if (!newInvoiceData.value.payment_steps_title) {
              newInvoiceData.value.payment_steps_title = "";
            }

            // 修復問題2：確保每個 cost_item 的 productOptions 正確載入
            // 需要在下一個 tick 執行，確保 props.productOptions 已經可用
            nextTick(() => {
              if (props.productOptions && props.productOptions.length > 0) {
                newInvoiceData.value.cost_items.forEach((item) => {
                  if (item.product_category_id) {
                    // 為每個項目設定對應的 productOptions
                    item.productOptions = props.productOptions.filter(
                      (product) => product.product_category_id == item.product_category_id
                    );
                    console.log(`為項目 ${item.item_description} 載入了 ${item.productOptions.length} 個產品選項`);
                  }
                });
              }
            });
          }
        }
      },
      { deep: true } // 添加deep選項以確保能檢測到深層變化
    );

    watch(
      () => props.invoiceData,
      (newVal) => {
        console.log("📥 props.invoiceData 更新:", newVal);
        isFirstLoadCustomer.value = true;
        isFirstLoadQuotation.value = true;

        // 保留已設置的 invoice_number（如果存在）
        const existingInvoiceNumber = newInvoiceData.value.invoice_number;
        console.log("💾 保存現有編號:", existingInvoiceNumber);

        // 保留用戶可能已經修改的備註內容
        const existingRemark = newInvoiceData.value.remark;
        const existingInvoiceRemark = newInvoiceData.value.invoice_remark;
        console.log("💾 保存現有備註:", { remark: existingRemark, invoice_remark: existingInvoiceRemark });

        newInvoiceData.value = { ...newVal };

        // 如果用戶已經修改了備註內容，保留用戶的修改
        if (existingRemark && existingRemark !== '' && existingRemark !== newVal.remark) {
          console.log("🔄 恢復用戶自訂的單據備註:", existingRemark);
          newInvoiceData.value.remark = existingRemark;
        }
        if (existingInvoiceRemark && existingInvoiceRemark !== '' && existingInvoiceRemark !== newVal.invoice_remark) {
          console.log("🔄 恢復用戶自訂的備註 Remarks:", existingInvoiceRemark);
          newInvoiceData.value.invoice_remark = existingInvoiceRemark;
        }

        // 處理後端返回的 paymentSteps 轉換為前端的 payment_steps
        if (newVal.payment_steps && Array.isArray(newVal.payment_steps)) {
          newInvoiceData.value.payment_steps = newVal.payment_steps;
        } else if (newVal.paymentSteps && Array.isArray(newVal.paymentSteps)) {
          newInvoiceData.value.payment_steps = newVal.paymentSteps;
        }

        // 同步 payment_steps_title
        if (newVal.payment_steps_title !== undefined) {
          newInvoiceData.value.payment_steps_title = newVal.payment_steps_title;
        }

        // 處理復制發票的特殊邏輯
        if (router.currentRoute.name == "invoice-copy") {
          console.log("� 處理復制發票邏輯...");
          newInvoiceData.value.id = 0;
          newInvoiceData.value.invoice_number = null;
          newInvoiceData.value.invoice_number_remark = "";
          newInvoiceData.value.cost_items = newInvoiceData.value.cost_items.map(
            (item) => {
              item.id = 0;
              return item;
            }
          );

          coupon_info.value.amount = 0;
          coupon_info.value.percentage = 0;
          coupon_info.value.title = null;
          gift_info.value.code = null;
          gift_info.value.amount = 0;
          if (newInvoiceData.value.coupon_record) {
            newInvoiceData.value.coupon_record = null;
          }
          if (newInvoiceData.value.gift_voucher_record) {
            newInvoiceData.value.gift_voucher_record = null;
          }
          newInvoiceData.value.total_amount = 0;

          // 復制發票後自動獲取新的發票編號
          console.log("🆕 復制發票需要新編號，自動獲取...");
          getNextInvoiceNumber();
        } else {
          // 如果新數據沒有 invoice_number 但我們已經設置了，則保留它
          if (!newInvoiceData.value.invoice_number && existingInvoiceNumber) {
            console.log("🔄 恢復編號:", existingInvoiceNumber);
            newInvoiceData.value.invoice_number = existingInvoiceNumber;
          }

          // 如果是新發票且沒有編號，自動獲取下一個編號
          if (
            (!newInvoiceData.value.id || newInvoiceData.value.id === 0) &&
            !newInvoiceData.value.invoice_number
          ) {
            console.log("🆕 新發票需要編號，自動獲取...");
            getNextInvoiceNumber();
          }
        }

        newInvoiceData.value.invoice_date = newInvoiceData.value.invoice_date
          ? newInvoiceData.value.invoice_date
          : getDateTime(new Date(), 1);

        if (newInvoiceData.value.coupon_record) {
          coupon_info.value.title = newInvoiceData.value.coupon_record.title;
          if (newInvoiceData.value.coupon_record.percentage) {
            coupon_info.value.percentage =
              newInvoiceData.value.coupon_record.percentage;
          } else {
            coupon_info.value.amount =
              newInvoiceData.value.coupon_record.amount;
          }
        }
        if (newInvoiceData.value.gift_voucher_record) {
          gift_info.value.code = newInvoiceData.value.gift_voucher_record.code;
          gift_info.value.amount =
            newInvoiceData.value.gift_voucher_record.amount;
        }

        changeTemplate(newInvoiceData.value.template_id);

        if (newInvoiceData.value.cost_items.length > 1) {
          newInvoiceData.value.cost_items.forEach((item) => {
            if (item.product_id && !item.size) {
              item.size = getProduct(item.product_id).size;
            }
          });
        }
      }
    );

    watch(
      () => newInvoiceData.value.invoice_description_id,
      (newVal) => {
        // 檢查是否為編輯模式的初始載入
        if (
          router.currentRoute.name === "invoice-edit" &&
          isInitInvoiceDescription.value
        ) {
          console.log("發票編輯模式初始載入，跳過單據備註自動填入");
          isInitInvoiceDescription.value = false;
          return;
        }

        if (
          props.invoiceDescriptionOptions &&
          props.invoiceDescriptionOptions.length > 0 &&
          newVal
        ) {
          const foundOption = props.invoiceDescriptionOptions.find(
            (ele) => ele.id == newVal
          );
          if (foundOption && foundOption.description) {
            console.log("用戶主動選擇發票單據備註，更新內容 - ID:", newVal, "內容:", foundOption.description);
            newInvoiceData.value.remark = foundOption.description;
          }
        }

        // trigger.value = !trigger.value;
      }
    );

    watch(
      () => newInvoiceData.value.remark_id,
      (newVal) => {
        console.log("發票 remark_id 變更:", newVal);

        // 檢查是否為編輯模式的初始載入
        if (
          router.currentRoute.name === "invoice-edit" &&
          isInitInvoiceRemarkId.value
        ) {
          console.log("發票編輯模式初始載入，跳過備註 Remarks 自動填入（remark_id watch）");
          isInitInvoiceRemarkId.value = false;
          return;
        }

        if (
          props.pdfRemarkOptions &&
          props.pdfRemarkOptions.length > 0 &&
          newVal
        ) {
          const foundOption = props.pdfRemarkOptions.find(
            (ele) => ele.id == newVal
          );
          if (foundOption && foundOption.content) {
            console.log("用戶主動選擇發票備註 Remarks，更新內容 - ID:", newVal, "內容:", foundOption.content);
            newInvoiceData.value.invoice_remark = foundOption.content;
          }
        }
      }
    );

    // 監聽 pdfRemarkOptions 的變化，當選項加載完成時設定備註內容
    watch(
      () => props.pdfRemarkOptions,
      (newVal) => {
        console.log("發票 pdfRemarkOptions 更新:", newVal);

        // 檢查是否為編輯模式的初始載入
        if (
          router.currentRoute.name === "invoice-edit" &&
          isInitInvoiceRemark.value
        ) {
          console.log("發票編輯模式初始載入，跳過備註 Remarks 自動填入");
          isInitInvoiceRemark.value = false;
          return;
        }

        if (newVal && newVal.length > 0 && newInvoiceData.value.remark_id) {
          const foundOption = newVal.find(
            (ele) => ele.id == newInvoiceData.value.remark_id
          );
          if (foundOption && foundOption.content) {
            console.log(
              "選項載入完成，自動填入發票備註模板內容 - ID:",
              newInvoiceData.value.remark_id,
              "內容:",
              foundOption.content
            );
            // 只有在 invoice_remark 為空時才自動填入模板內容
            if (!newInvoiceData.value.invoice_remark || newInvoiceData.value.invoice_remark === '') {
              newInvoiceData.value.invoice_remark = foundOption.content;
            }
          }
        }
      },
      { immediate: true }
    );

    const couponOptions = ref([]);
    const giftOptions = ref([]);
    const getUserCoupon = (id) => {
      store
        .dispatch("app/getUserCoupon", {
          customer_id: id,
        })
        .then((response) => {
          couponOptions.value = response.data.coupons;
        });

      store
        .dispatch("app/getUserGiftVoucher", {
          customer_id: id,
        })
        .then((response) => {
          giftOptions.value = response.data.gift_vouchers;
        });
    };

    const resetCoupon = () => {
      if (
        router.currentRoute.name == "invoice-create" &&
        !router.currentRoute.query.quotation_id
      ) {
        coupon_info.value.amount = 0;
        gift_info.value.amount = 0;
        newInvoiceData.value.coupon_id = null;
        newInvoiceData.value.gift_voucher_id = null;
      }
    };

    const getProduct = (id) => {
      if (id) {
        const obj =
          props.productOptions &&
          props.productOptions.length > 0 &&
          props.productOptions.filter((ele) => ele.id == id)[0];
        return { ...{ unit: "次" }, ...obj };
      } else {
        return { unit: "次" };
      }
    };

    const updateSelectedProduct = (_product, _product_id) => {
      let product = getProduct(_product_id);
      _product.quantity = 1;
      _product.size = product.size;
      _product.unit_price = product.unit_price;
      _product.item_description =
        product.product_name + (product.remark ? "\n" + product.remark : "");
      _product.amount = Number(_product.quantity) * Number(_product.unit_price);
      calTotalAmount();
    };

    const calTotalCost = (item) => {
      if (item.quantity && item.unit_price) {
        item.amount =
          Math.round(Number(item.quantity) * Number(item.unit_price) * 10) / 10;
        calTotalAmount();
      }
    };
    const calTotalAmount = () => {
      let total = 0;

      if (
        newInvoiceData.value.cost_items &&
        newInvoiceData.value.cost_items.length > 0
      ) {
        total += newInvoiceData.value.cost_items.reduce(
          (a, b) =>
            a +
            (Number(b.quantity) * Number(b.unit_price)
              ? Number(b.quantity) * Number(b.unit_price)
              : 0),
          0
        );
      }
      newInvoiceData.value.amount = Math.round(total * 100) / 100;
      total_amount.value =
        Math.round(
          (Number(newInvoiceData.value.amount) -
            Number(coupon_info.value.amount) -
            Number(gift_info.value.amount)) *
            100
        ) / 100;

      total_amount.value =
        total_amount.value > 0 ? Math.round(total_amount.value * 100) / 100 : 0;

      // 當總額變更時，重新計算 payment_steps 金額
      calculatePaymentStepAmounts();
    };

    // 計算 payment_steps 金額
    const calculatePaymentStepAmounts = () => {
      if (
        newInvoiceData.value.payment_steps &&
        newInvoiceData.value.payment_steps.length > 0 &&
        newInvoiceData.value.amount > 0
      ) {
        newInvoiceData.value.payment_steps.forEach((step) => {
          if (step.step_percentage && step.step_percentage > 0) {
            step.step_amount =
              Math.round(
                ((Number(newInvoiceData.value.amount) *
                  Number(step.step_percentage)) /
                  100) *
                  100
              ) / 100;
          }
        });
      }
    };

    // 驗證 payment_steps 佔比總和
    const validatePaymentStepPercentages = () => {
      if (
        !newInvoiceData.value.payment_steps ||
        newInvoiceData.value.payment_steps.length === 0
      ) {
        return { isValid: true, message: "" };
      }

      const totalPercentage = newInvoiceData.value.payment_steps.reduce(
        (sum, step) => sum + (Number(step.step_percentage) || 0),
        0
      );

      if (totalPercentage !== 100) {
        return {
          isValid: false,
          message: `階段付款佔比總和必須等於 100%，目前為 ${totalPercentage}%`,
        };
      }

      return { isValid: true, message: "" };
    };

    // 處理 payment_steps 佔比變更
    const handlePaymentStepPercentageChange = (step, index) => {
      // 計算該步驟的金額
      if (step.step_percentage && newInvoiceData.value.amount > 0) {
        step.step_amount =
          Math.round(
            ((Number(newInvoiceData.value.amount) *
              Number(step.step_percentage)) /
              100) *
              100
          ) / 100;
      } else {
        step.step_amount = 0;
      }
    };

    // 計算佔比總和的 computed 屬性
    const totalPercentage = computed(() => {
      if (
        !newInvoiceData.value.payment_steps ||
        newInvoiceData.value.payment_steps.length === 0
      ) {
        return 0;
      }
      return newInvoiceData.value.payment_steps.reduce(
        (sum, step) => sum + (Number(step.step_percentage) || 0),
        0
      );
    });

    // 檢查佔比是否有效的 computed 屬性
    const isPercentageValid = computed(() => {
      return totalPercentage.value === 100;
    });

    const getCoupon = (id) => {
      if (id) {
        const obj =
          couponOptions.value &&
          couponOptions.value.length > 0 &&
          couponOptions.value.find((ele) => ele.id == id);
        return { ...obj };
      } else {
        return;
      }
    };
    const getGift = (id) => {
      if (id) {
        const obj =
          giftOptions.value &&
          giftOptions.value.length > 0 &&
          giftOptions.value.find((ele) => ele.id == id);

        return { ...obj };
      } else {
        return;
      }
    };

    const resetInvoiceData = () => {
      newInvoiceData.value = JSON.parse(
        JSON.stringify({
          id: 0,
          stamp: 1,
          invoice_number: null,
          invoice_number_remark: "",
          cost_items: [{ id: 0 }],
          amount: 0,
          quotation_id: null,
          project_id: null,
          coupon_id: null,
          gift_voucher_id: null,
          project_name: null,
          address: null,
          payment_steps: [
            {
              id: 0,
              step_name: "",
              step_percentage: 0,
              step_amount: 0,
            },
          ],
          payment_steps_title: "",
        })
      );
    };

    const loading = ref(false);

    // 獲取下一個發票編號
    const getNextInvoiceNumber = async () => {
      try {
        console.log("🔄 開始獲取發票編號...");
        loadingInvoiceNumber.value = true;
        invoiceNumberValidation.value = { message: "", isValid: true };

        const response = await store.dispatch("invoice/getNextInvoiceNumber");
        if (response.data && response.data.invoice_number) {
          console.log("✅ 成功獲取發票編號:", response.data.invoice_number);
          newInvoiceData.value.invoice_number = response.data.invoice_number;
          invoiceNumberValidation.value = {
            message: "已自動生成編號",
            isValid: true,
          };
        }
      } catch (error) {
        console.error("❌ 獲取發票編號失敗:", error);
        invoiceNumberValidation.value = {
          message: "獲取編號失敗，請手動輸入",
          isValid: false,
        };
      } finally {
        loadingInvoiceNumber.value = false;
      }
    };

    const onInvoiceNumberInput = () => {
      // 清除之前的驗證結果，等待用戶完成輸入
      invoiceNumberValidation.value = { message: "", isValid: true };
    };

    // 驗證發票編號唯一性
    const validateInvoiceNumber = async () => {
      if (!newInvoiceData.value.invoice_number) {
        invoiceNumberValidation.value = { message: "", isValid: true };
        return;
      }

      try {
        const response = await store.dispatch("invoice/validateInvoiceNumber", {
          invoice_number: newInvoiceData.value.invoice_number,
          exclude_id:
            newInvoiceData.value.id > 0 ? newInvoiceData.value.id : null,
        });

        if (response.data) {
          invoiceNumberValidation.value = {
            message: response.data.message,
            isValid: response.data.is_unique,
          };
        }
      } catch (error) {
        invoiceNumberValidation.value = {
          message: "驗證失敗",
          isValid: false,
        };
        console.error("驗證發票編號失敗:", error);
      }
    };

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetInvoiceData);

    // 組件掛載時自動獲取發票編號
    onMounted(() => {
      console.log("🚀 組件已掛載，檢查發票編號...");
      console.log("📊 當前數據:", {
        id: newInvoiceData.value.id,
        invoice_number: newInvoiceData.value.invoice_number,
      });

      // 如果是新發票且沒有編號，自動獲取下一個編號
      if (
        (!newInvoiceData.value.id || newInvoiceData.value.id === 0) &&
        !newInvoiceData.value.invoice_number
      ) {
        console.log("🎯 符合條件，開始獲取編號...");
        getNextInvoiceNumber();
      } else {
        console.log("⏭️ 不需要獲取編號");
      }
    });

    // payment_steps_title 現在直接使用 newInvoiceData.payment_steps_title，不需要額外的 watch

    return {
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      newInvoiceData,
      getProduct,
      calTotalCost,
      calTotalAmount,
      updateSelectedProduct,
      trigger,
      couponOptions,
      giftOptions,
      getGift,
      getCoupon,
      coupon_info,
      gift_info,
      total_amount,
      changeTemplate,
      info,
      // 新增的發票編號相關功能
      loadingInvoiceNumber,
      invoiceNumberValidation,
      getNextInvoiceNumber,
      validateInvoiceNumber,
      onInvoiceNumberInput,
      // 新增的 payment_steps 相關功能
      calculatePaymentStepAmounts,
      validatePaymentStepPercentages,
      handlePaymentStepPercentageChange,
      totalPercentage,
      isPercentageValid,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss" scoped>
ol li {
  margin-bottom: 0.5rem;
}
.label-title {
  width: 186px;
}
</style>
